((/*Discount animation*/) => {
    const applyScrollAnimation = (elements) => {
        elements.forEach(element => {
            const scrollText = element.querySelector('.scroll-text');

            if (!scrollText) return;

            setTimeout(() => {
                if (scrollText.offsetHeight > 30) {
                    scrollText.style.whiteSpace = 'nowrap';
                    scrollText.style.animation = 'scroll-left 10s linear infinite';

                    const spans = scrollText.querySelectorAll('span');
                    const parentWidth = scrollText.parentElement.offsetWidth;

                    spans.forEach(span => {
                        span.setAttribute('style', `margin-left: ${parentWidth}px !important;`);
                    })
                }
            });
        });
    };

    const observeDynamicElements = (selector, callback) => {
        const observer = new MutationObserver(() => {
            const newElements = document.querySelectorAll(selector);
            if (newElements.length) callback(newElements);
        });

        observer.observe(document.body, {attributeFilter: ["style"], childList: true, subtree: true});
    };

    const discountElements = document.querySelectorAll('.sale_planning_widget');

    applyScrollAnimation(discountElements);

    observeDynamicElements('.sale_planning_widget', applyScrollAnimation);
})();

if ($(".section-plannings")[0]) {
  function onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
  }

  function natsort($array) {
      return $array.sort(function (a, b) {
          if (isNaN(a) && isNaN(b)) {
              if (a <= b) {
                  return false;
              } else {
                  return true;
              }
          }
          if (isNaN(a)) {
              return true;
          }
          if (isNaN(b)) {
              return false;
          }
          return a - b;
      });
  }


  function getPlannings() {
      let newPlannings = "";
      let sections = [];
      let html_lang_attr = $("html").attr('lang').split('-')

      let lang_code = (html_lang_attr[0] === "uk") ? "" : "/" + html_lang_attr[0];
      $.ajax({
          url: "https://blagodeveloper.com/wp-json/planningFilter/v1?project=1495&template=for-project&plannings_count=-1",
          type: "GET",
          data: {},
          success: function (plannings) {
              if (plannings.length !== 0) {
                  let project_tag = $('.descr-section__plan-project-price')
                  if (plannings.project) {
                      let {project_price, project_currency} = plannings.project,
                          project_tag_price = project_tag.find('span.p-price'),
                          project_tag_currency = project_tag.find('span.p-currency')

                      if (project_price && project_currency) {
                          let formattedPrice = project_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                          project_tag_price.text(formattedPrice)
                          project_tag_price.attr('data-price', project_price)
                          if (project_currency === 'uah') {
                              project_tag_currency.text('грн')
                          }
                      } else {
                          project_tag.remove()
                      }
                  } else {
                      project_tag.remove()
                  }
                  plannings.PLANNINGS.sort((a, b) => {
                      return a.COMPLETE_STAGE - b.COMPLETE_STAGE;
                  });
                  plannings.PLANNINGS.forEach(function (planning) {
                      let complete_type = (planning.COMPLETE_TYPE !== "Немає" && planning.COMPLETE_TYPE != null) ?
                          "<div class='sale_planning_widget'><span class='scroll-text'>" + planning.COMPLETE_TYPE + "</span></div>" : "";

                      if (planning.IS_DISCOUNT && planning.DISCOUNT_TEXT !== "") {
                          complete_type = "<div class='sale_planning_widget scroll-text'><span class='scroll-text'>" + planning.DISCOUNT_TEXT + "</span></div>";
                      }
                      let complete_prosses;
                      if(planning.COMPLETE_STAGE){
                          complete_prosses = '' +
                              '<div class="process">' +
                              '<div class="process-num">'+ planning.COMPLETE_STAGE +'</div>% готовність' +
                              '<div class="process-line" style="width:'+ planning.COMPLETE_STAGE +'%"></div>'+
                              '</div>';
                      } else {
                          complete_prosses = '';
                      }

                      $('ul.descr-box__list').append(
                          "<li class='descr-box__items' data-section='" + planning.OBJECT_TYPE + " " + planning.SECTION + "' data-section-price='" + planning.SECTION_PRICE + "'>" +
                          "<a class='descr-box__holder fancybox' href='" + planning.FLOOR_IMG_URL + "' data-fancybox='" + planning.OBJECT_TYPE + " " + planning.SECTION + "' data-id='" + planning.ITERATION_ID + "'>" +
                          "<div class='descr-box__group'>" +
                          "<div class='descr-box__img'></div>" +
                          "<div class='descr-box__square'>" + planning.SQUARE + " м<sup>2</sup> </div></div>" +
                          "<div class='descr-box__rooms'>" + planning.ROOMS_COUNT + "-кімнатна</div>" +
                          complete_type +
                          complete_prosses +
                          "</a></li>"
                      )
                  })
                  // $("#plannings_loader").hide();
                  // $(".planning_list").show();
                  // $(".descr-box__list").html(newPlannings);
                  $("li.descr-box__items").each(function (i, elem) {
                      sections.push($(this).find("a.descr-box__holder.fancybox").attr("data-fancybox"));
                  })
                  sections = sections.filter(onlyUnique);
                  sections.sort((a, b) => b.localeCompare(a, navigator.languages[0] || navigator.language, {
                      numeric: true,
                      ignorePunctuation: true
                  }));
                  sections.forEach(function (section, i) {
                      let active = (i == 0) ? "active" : "";
                      $('.descr-section__plan-tabs ul.tabs-list').append('<li class="tabs-items " data-section="' + section + '"><a class="tabs-link ' + active + '" href="#" >' + section + '</a></li>&nbsp;');
                  })
                  $('.descr-section__plan-tabs .tabs-list .tabs-items:first-child').click();

              }
              let targetValueMap = new Map();
              let intervalMap = new Map();

              $('.descr-box__holder').on('mouseenter', function () {
                  let $this = $(this);
                  if ($this.find('.process').length > 0) {
                      let plannindItemId = $this.data('id');
                      let plannindItemStage = parseInt($this.find('.process-num').text());

                      targetValueMap.set(plannindItemId, plannindItemStage);

                      if (intervalMap.has(plannindItemId)) {
                          clearInterval(intervalMap.get(plannindItemId));
                      }

                      let count = 0;
                      let interval = setInterval(function () {
                          if (count >= plannindItemStage) {
                              clearInterval(interval);
                              intervalMap.delete(plannindItemId);
                              return;
                          }
                          count++;
                          $this.find('.process-num').html(count);
                          $this.find('.process-line').css('width', `${count}%`);
                      }, 10);

                      intervalMap.set(plannindItemId, interval);
                  }
              }).on('mouseleave', function () {
                  let $this = $(this);
                  let plannindItemId = $this.data('id');

                  if (intervalMap.has(plannindItemId)) {
                      clearInterval(intervalMap.get(plannindItemId));
                      intervalMap.delete(plannindItemId);
                  }

                  let targetValue = targetValueMap.get(plannindItemId) || 0;
                  $this.find('.process-num').html(targetValue);
                  $this.find('.process-line').css('width', `${targetValue}%`);
              });
          }

      })
  }

  getPlannings();


  $(document).on('click', '.descr-section__plan-tabs ul.tabs-list li', function (e) {
      e.preventDefault();
      $(".descr-section__plan-tabs ul.tabs-list li a.tabs-link").removeClass('active');
      $(this).find("a.tabs-link").addClass('active');
      let this_section = $(this).attr('data-section');
      $('li.descr-box__items').hide();
      $('li.descr-box__items[data-section="' + this_section + '"]').show();

      let projectTag = $('.descr-section__plan-project-price');
      if (projectTag.length) {
          let projectTagPrice = projectTag.find('span.p-price'),
              projectPrice = $('li.descr-box__items[data-section="' + this_section + '"]').data('section-price') || projectTagPrice.data('price');

          projectTagPrice.text(projectPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "));
      }
  })
}
